/**
 * Secteurs et métiers (données statiques)
 *
 * Rôle : Secteurs d'activité et listes de métiers associés ; getMetiersForSector(sector), getSectorOptions().
 * Utilisé par inscription, compte (informations), marketplace. Technologies : TypeScript (const, export)
 */
const rawSectorMetiers: Record<string, string[]> = {
  Marine: [
    "Accastillage",
    "Algoculture",
    "Aquaculture",
    "Architecte naval",
    "Câblage et cordage",
    "Chantier naval",
    "Charpente navale",
    "Chaudronnerie marine",
    "Climatisation marine",
    "Conchyliculture",
    "Électricité marine",
    "Électronique marine",
    "Énergies marines renouvelables",
    "Gréeur",
    "Maintenance navale",
    "Mécanique marine",
    "Motorisation",
    "Mytiliculture",
    "Navigation maritime",
    "Peinture marine",
    "Pisciculture",
    "Plomberie marine",
    "Pêche",
    "Réparation moteurs",
    "Scaphandrier",
    "Soudeur naval",
    "Transformation produits de la mer",
    "Traitement des eaux",
    "Tuyauteur marine",
    "Voilerie",
    "Voilier-sellier",
  ],
  "Société de services": [
    "Audit",
    "Comptabilité",
    "Conseil",
    "Conseil en stratégie",
    "Formation",
    "Gestion de patrimoine",
    "Informatique",
    "Intérim",
    "Juridique",
    "Marketing",
    "Nettoyage",
    "Notariat",
    "Ressources humaines",
    "Sécurité",
    "Secrétariat",
    "Support technique",
    "Traduction",
    "Urbanisme",
  ],
  Construction: [
    "Canalisateur",
    "Carreleur",
    "Charpentier",
    "Chaudronnier",
    "Chauffagiste",
    "Climatisation",
    "Conducteur d'engins",
    "Couverture",
    "Électricien",
    "Façadier",
    "Gros œuvre",
    "Installateur thermique",
    "Maçon",
    "Menuisier",
    "Métreur",
    "Ouvrage d'art",
    "Peintre",
    "Plaquiste",
    "Plombier",
    "Réseaux électriques",
    "Serrurier",
    "Terrassement",
    "Travaux publics",
    "Vitrier",
  ],
  Commerce: [
    "Achat",
    "Boucher",
    "Boulanger",
    "Commerce de détail",
    "Commerce de gros",
    "Coiffeur",
    "E-commerce",
    "Équipement industriel",
    "Esthéticien",
    "Fleuriste",
    "Fournitures bureau",
    "Matériel médical",
    "Négoce",
    "Pièces détachées",
    "Quincaillerie",
    "Représentant commercial",
    "Technico-commercial",
    "Vente matériel",
  ],
  Alimentation: [
    "Boucher",
    "Boulanger",
    "Brasseur",
    "Charcutier",
    "Chocolatier-confiseur",
    "Crêpier",
    "Fromager",
    "Glacier",
    "Pâtissier",
    "Poissonnier",
    "Primeur",
    "Restauration collective",
    "Traiteur",
  ],
  Hôtellerie: [
    "Bar",
    "Cuisine",
    "Événementiel",
    "Hébergement",
    "Réception",
    "Restauration",
    "Room service",
    "Traiteur",
  ],
  Industrie: [
    "Agroalimentaire",
    "Automatisme",
    "Chaudronnier",
    "Confection textile",
    "Contrôle qualité",
    "Logistique",
    "Maintenance industrielle",
    "Métallurgie",
    "Plasturgie",
    "Robotique",
    "Sous-traitance",
    "Tourneur-fraiseur",
    "Usinage",
    "Études et conception",
  ],
};

// Normaliser pour recherche (sans accents)
function normalizeForSearch(s: string): string {
  return s
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}

export const SECTOR_METIERS: Record<string, string[]> = Object.fromEntries(
  Object.entries(rawSectorMetiers).map(([sector, list]) => [
    sector,
    [...list].sort((a, b) => a.localeCompare(b, "fr")),
  ])
);

export function getMetiersForSector(sector: string): string[] {
  return SECTOR_METIERS[sector] ?? [];
}

export function filterMetiers(metiers: string[], search: string): string[] {
  const q = normalizeForSearch(search.trim());
  if (!q) return metiers;
  return metiers.filter((m) => normalizeForSearch(m).includes(q));
}
